import React from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import Fax from './Fax';
import SortIcons from './ProposalsSortIcons';
const FaxList = ({
  faxes = [],
  onSelectNumber,
  onDownload,
  onDelete,
  onCancel,
  onResend,
  user,
  incomingFaxes,
  deleteMode,
  onRecover,
  onSort,
  sortValue,
}) => {
  if (incomingFaxes) {
    faxes = [];
  }
  return (
    <div className="table-header-fixed">
      <table>
        <thead>
          <tr>
            {/* {(user.role === "superAdmin" || user.role === 'companyGroupAdmin') && <th>Fax ID</th>} */}
            <th
              className="cursor-pointer"
              onClick={() => faxes.length > 0 && onSort('company[name]')}
            >
              Company Name <SortIcons sortObj={sortValue} sortName="company[name]" />
            </th>
            <th className="cursor-pointer" onClick={() => faxes.length > 0 && onSort('reason')}>
              Description <SortIcons sortObj={sortValue} sortName="reason" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => faxes.length > 0 && onSort('user[email]')}
            >
              User <SortIcons sortObj={sortValue} sortName="user[email]" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => faxes.length > 0 && onSort('totalPages')}
            >
              Page Count <SortIcons sortObj={sortValue} sortName="totalPages" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => faxes.length > 0 && onSort('updatedOn')}
            >
              Date/Time <SortIcons sortObj={sortValue} sortName="updatedOn" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => faxes.length > 0 && onSort('relayNumber')}
            >
              CID <SortIcons sortObj={sortValue} sortName="relayNumber" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => faxes.length > 0 && onSort('destinationNumber')}
            >
              Destination <SortIcons sortObj={sortValue} sortName="destinationNumber" />
            </th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {faxes.length ? (
            faxes.map(fax => (
              <Fax
                onRecover={onRecover}
                deleteMode={deleteMode}
                key={fax._id}
                onSelectNumber={onSelectNumber}
                fax={fax}
                onDelete={onDelete}
                onCancel={onCancel}
                onResend={onResend}
                onDownload={onDownload}
              />
            ))
          ) : (
            <tr>
              <td colSpan={12}>
                <Alert rowSpan={12} color="info">
                  No Faxes Found
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
});

export default connect(mapStateToProps)(FaxList);
